<template>
  <!-- 员工日志弹窗 -->
  <a-modal
    :title="`员工日志 - ${userName || ''}`"
    :visible="isVisible"
    :width="1200"
    :footer="null"
    :maskClosable="false"
    @cancel="handleCancel"
    @ok="handleCancel"
    :destroyOnClose="true"
    :closable="true"
    class="employee-log-modal"
  >
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 16px">
      <a-form layout="inline" :model="queryParam">
        <a-row :gutter="48">
          <!-- 收起状态 -->
          <template v-if="!advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="员工姓名">
                <a-input
                  v-model:value="queryParam.nickName"
                  placeholder="请输入员工姓名"
                  allow-clear
                  @keyup.enter="handleQuery"
                  :disabled="loading"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="时间">
                <a-date-picker
                  v-model:value="queryParam.operationTime"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择时间"
                  allow-clear
                  :disabled="loading"
                />
              </a-form-item>
            </a-col>

            <!-- 收起状态下的按钮 -->
            <a-col :md="8" :sm="24">
              <a-form-item>
                <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                  <a-button
                    type="primary"
                    class="search-btn"
                    @click="handleQuery"
                    :loading="loading"
                    :disabled="loading"
                  >
                    查询
                  </a-button>
                  <a-button class="reset-btn" @click="handleReset" :disabled="loading" style="margin-left: 8px">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                    展开
                    <DownOutlined />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>

          <!-- 展开状态 -->
          <template v-else>
            <!-- 第一行 -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="员工姓名">
                <a-input
                  v-model:value="queryParam.nickName"
                  placeholder="请输入员工姓名"
                  allow-clear
                  @keyup.enter="handleQuery"
                  :disabled="loading"
                />
              </a-form-item>
            </a-col>
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="时间">
                <a-date-picker
                  v-model:value="queryParam.operationTime"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择时间"
                  allow-clear
                  :disabled="loading"
                />
              </a-form-item>
            </a-col>
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="事由">
                <a-input
                  v-model:value="queryParam.operationReason"
                  placeholder="请输入事由"
                  allow-clear
                  @keyup.enter="handleQuery"
                  :disabled="loading"
                />
              </a-form-item>
            </a-col>
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="操作人">
                <a-input
                  v-model:value="queryParam.operationName"
                  placeholder="请输入操作人"
                  allow-clear
                  @keyup.enter="handleQuery"
                  :disabled="loading"
                />
              </a-form-item>
            </a-col>

            <!-- 第二行：按钮行 -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8"></a-col>
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8"></a-col>
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button
                    type="primary"
                    class="search-btn"
                    @click="handleQuery"
                    :loading="loading"
                    :disabled="loading"
                  >
                    查询
                  </a-button>
                  <a-button class="reset-btn" @click="handleReset" :disabled="loading" style="margin-left: 8px">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                    收起
                    <UpOutlined />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮 -->
    <div class="table-operations">
      <!-- <a-tooltip title="刷新"> -->
      <img
        src="@/assets/images/projectUser/refresh.png"
        alt="刷新"
        class="refresh-icon"
        @click="handleRefresh"
        :class="{ disabled: loading }"
      />
      <!-- </a-tooltip> -->
      <a-button
        class="export-btn"
        @click="handleExport"
        :disabled="!list || list.length === 0 || pagination.total === 0 || loading"
        v-hasPermi="exportPermission"
      >
        <template #icon><UploadOutlined /></template>
        导出
      </a-button>
      <!-- <span class="data-total" v-if="list.length > 0">
        共 {{ pagination.total }} 条记录，当前显示 {{ list.length }} 条
      </span> -->
    </div>

    <!-- 数据表格 -->
    <div class="table-container">
      <a-spin :spinning="loading" tip="加载中...">
        <div v-if="list && list.length > 0">
          <a-table
            :columns="columns"
            :data-source="list"
            :pagination="false"
            :loading="false"
            :row-selection="rowSelection"
            rowKey="id"
            size="small"
            @change="handleTableChange"
            :scroll="{ x: 'max-content', y: 400 }"
            bordered
            :showSorterTooltip="false"
            class="optimized-table"
          >
            <template #index="{ index }">
              <span class="index-column">
                {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
              </span>
            </template>
            <template #operationTime="{ text }">
              <span class="time-column">
                {{ parseTime(text) }}
              </span>
            </template>
            <template #operationReason="{ text }">
              <span class="reason-column" :title="text">
                {{ text || '-' }}
              </span>
            </template>
            <template #operationRemark="{ text }">
              <span class="remark-column" :title="text">
                {{ text || '-' }}
              </span>
            </template>
            <template #emptyText>
              <div class="empty-container">
                <a-empty description="暂无数据" />
              </div>
            </template>
          </a-table>
        </div>
        <div v-else-if="loading">
          <!-- 加载中状态已在 spin 组件中显示 -->
        </div>
        <div v-else>
          <div class="empty-container">
            <a-empty :description="emptyDescription" />
          </div>
        </div>
      </a-spin>
    </div>

    <!-- 分页组件 -->
    <div class="pagination-wrapper" v-if="list && list.length > 0">
      <div class="pagination-left">
        <span class="pagination-info">
          显示第 {{ (pagination.current - 1) * pagination.pageSize + 1 }} 到第
          {{ Math.min(pagination.current * pagination.pageSize, pagination.total) }} 条数据/共 {{ pagination.total }} 条
        </span>
        <a-select
          v-model:value="pagination.pageSize"
          style="width: 100px; margin-left: 8px"
          @change="onShowSizeChange(pagination.current, pagination.pageSize)"
          class="no-border-radius-select"
        >
          <a-select-option :value="10">10条/页</a-select-option>
          <a-select-option :value="20">20条/页</a-select-option>
          <a-select-option :value="50">50条/页</a-select-option>
          <a-select-option :value="100">100条/页</a-select-option>
        </a-select>
      </div>
      <div class="pagination-right">
        <a-pagination
          :current="pagination.current"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          :show-total="false"
          @change="changeSize"
        />
        <span class="pagination-jump">
          到第
          <a-input-number
            v-model:value="jumpPage"
            :min="1"
            :max="Math.ceil(pagination.total / pagination.pageSize)"
            style="width: 60px; margin: 0 4px"
            @pressEnter="handleJumpPage"
            class="no-border-radius-input-number"
          />
          页
        </span>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick } from 'vue'
import { Modal, message } from 'ant-design-vue'
import {
  SearchOutlined,
  RedoOutlined,
  DownloadOutlined,
  UploadOutlined,
  UpOutlined,
  DownOutlined,
} from '@ant-design/icons-vue'
import { pageUserLog } from '@/api/system/userLog'
import { download } from '@/utils/request'
import { parseTime } from '@/utils/ruoyi'

defineOptions({
  name: 'EmployeeLog',
})

const props = defineProps({
  // 使用 visible 控制显示
  visible: {
    type: Boolean,
    default: false,
  },
  userId: {
    type: [Number, String],
    required: true,
  },
  userName: {
    type: String,
    default: '',
  },
  permissionPrefix: {
    type: String,
    default: 'system:userLog',
  },
})

const emit = defineEmits(['update:visible', 'close'])

// 弹窗显示状态
const isVisible = computed(() => props.visible)

// 空状态描述
const emptyDescription = computed(() => {
  const hasSearch = Object.values(queryParam).some((val) => val !== undefined && val !== null && val !== '')
  return hasSearch ? '没有找到匹配的日志记录' : '暂无员工日志数据'
})

// 数据相关
const list = ref([])
const loading = ref(false)
const selectedRowKeys = ref([])
const selectedRows = ref([])
// 高级搜索 展开/收起
const advanced = ref(false)

// 查询参数
const queryParam = reactive({
  operationTime: undefined,
  operationReason: undefined,
  operationName: undefined,
  nickName: undefined,
})

// 分页配置
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: false, // 隐藏分页器左侧的总数显示（如"1-1"）
  pageSizeOptions: ['10', '20', '50', '100'],
})
// 跳转页码
const jumpPage = ref(1)

// 行选择配置
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: onSelectChange,
  columnWidth: 60,
  fixed: true,
}))

// 表格列定义
const columns = ref([
  {
    title: '序号',
    key: 'index',
    align: 'center',
    width: 80,
    slots: { customRender: 'index' },
    fixed: 'left',
  },
  {
    title: '员工姓名',
    dataIndex: 'nickName',
    align: 'center',
    width: 120,
    ellipsis: true,
  },
  {
    title: '时间',
    dataIndex: 'operationTime',
    align: 'center',
    width: 180,
    slots: { customRender: 'operationTime' },
    sorter: true,
  },
  {
    title: '事由',
    dataIndex: 'operationReason',
    align: 'center',
    width: 200,
    slots: { customRender: 'operationReason' },
    ellipsis: true,
  },
  {
    title: '操作人',
    dataIndex: 'operationName',
    align: 'center',
    width: 120,
    ellipsis: true,
  },
  {
    title: '备注',
    dataIndex: 'operationRemark',
    align: 'center',
    width: 200,
    slots: { customRender: 'operationRemark' },
    ellipsis: true,
  },
])

/** 刷新权限 */
const refreshPermission = computed(() => {
  return [`${props.permissionPrefix}:refresh`]
})

/** 导出权限 */
const exportPermission = computed(() => {
  return [`${props.permissionPrefix}:export`]
})

// 监听弹窗打开状态
watch(
  () => props.visible,
  (newVal) => {
    console.log('EmployeeLog 弹窗状态变化:', newVal ? '打开' : '关闭')

    if (newVal) {
      // 弹窗打开时加载数据
      nextTick(() => {
        if (props.userId) {
          loadData()
        } else {
          console.warn('userId为空，无法加载数据')
          message.warning('用户信息缺失，无法加载日志')
        }
      })
    } else {
      // 弹窗关闭时重置数据
      resetState()
    }
  }
)

// 监听userId变化
watch(
  () => props.userId,
  (newVal) => {
    if (props.visible && newVal) {
      console.log('userId变化，重新加载数据:', newVal)
      loadData()
    }
  }
)

/** 加载数据 */
const loadData = () => {
  console.log('开始加载数据，userId:', props.userId)
  pagination.current = 1
  jumpPage.value = 1
  selectedRowKeys.value = []
  selectedRows.value = []
  fetchData()
}

/** 重置状态 */
const resetState = () => {
  list.value = []
  selectedRowKeys.value = []
  selectedRows.value = []
  queryParam.operationTime = undefined
  queryParam.operationReason = undefined
  queryParam.operationName = undefined
  queryParam.nickName = undefined
  pagination.current = 1
  pagination.total = 0
  jumpPage.value = 1
  loading.value = false
}

/** 获取员工日志列表 */
const fetchData = async () => {
  try {
    if (!props.userId) {
      message.warning('用户ID不能为空')
      return
    }

    if (!props.visible) {
      console.log('弹窗未打开，取消请求')
      return
    }

    loading.value = true

    // 构建查询参数
    const params = {
      userId: props.userId,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }

    // 添加可选查询条件
    if (queryParam.operationTime) params.operationTime = queryParam.operationTime
    if (queryParam.operationReason) params.operationReason = queryParam.operationReason
    if (queryParam.operationName) params.operationName = queryParam.operationName
    if (queryParam.nickName) params.nickName = queryParam.nickName

    console.log('请求参数:', params)

    // 发送请求
    const response = await pageUserLog(params)

    console.log('接口响应:', response)

    // 处理响应数据 - 根据您的响应格式 {code: '20001', success: true, message: '成功.', data: {...}}
    let dataList = []
    let totalCount = 0

    if (response && response.success === true && response.data) {
      console.log('data结构:', response.data)

      // 尝试多种可能的数据路径
      if (response.data.records && Array.isArray(response.data.records)) {
        dataList = response.data.records
        totalCount = response.data.total || 0
      } else if (response.data.list && Array.isArray(response.data.list)) {
        dataList = response.data.list
        totalCount = response.data.total || 0
      } else if (Array.isArray(response.data)) {
        dataList = response.data
        totalCount = response.data.length || 0
      } else if (response.data.data && Array.isArray(response.data.data)) {
        dataList = response.data.data
        totalCount = response.data.total || response.data.data.length || 0
      } else {
        // 尝试遍历查找数组
        const findArrayInObject = (obj) => {
          for (const key in obj) {
            if (Array.isArray(obj[key])) {
              return obj[key]
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
              const result = findArrayInObject(obj[key])
              if (result) return result
            }
          }
          return []
        }

        dataList = findArrayInObject(response.data)
        if (dataList.length > 0) {
          totalCount = response.data.total || dataList.length || 0
        }
      }
    }

    // 设置数据
    list.value = dataList
    pagination.total = totalCount
    jumpPage.value = pagination.current

    console.log('数据处理结果:', {
      数据条数: dataList.length,
      总数: totalCount,
      当前页: pagination.current,
      每页条数: pagination.pageSize,
    })

    // 如果当前页没有数据且不是第一页，则返回前一页
    if (dataList.length === 0 && pagination.current > 1) {
      pagination.current -= 1
      await fetchData()
      return
    }
  } catch (error) {
    console.error('获取员工日志失败:', error)

    let errorMessage = '数据加载失败'
    if (error.message?.includes('Network')) {
      errorMessage = '网络连接失败'
    } else if (error.message?.includes('timeout')) {
      errorMessage = '请求超时'
    }

    message.error(errorMessage)

    list.value = []
    pagination.total = 0
  } finally {
    loading.value = false
  }
}

/** 查询 */
const handleQuery = () => {
  if (loading.value) return

  pagination.current = 1
  jumpPage.value = 1
  selectedRowKeys.value = []
  selectedRows.value = []

  fetchData()
}

/** 重置查询条件 */
const handleReset = () => {
  if (loading.value) return

  Object.assign(queryParam, {
    operationTime: undefined,
    operationReason: undefined,
    operationName: undefined,
    nickName: undefined,
  })

  handleQuery()
}

/** 展开/收起切换 */
const toggleAdvanced = () => {
  advanced.value = !advanced.value
}

/** 按钮样式 */
const submitButtonStyle = computed(() => {
  return advanced.value ? { float: 'left', overflow: 'hidden' } : {}
})

/** 刷新数据 */
const handleRefresh = () => {
  if (loading.value) return

  fetchData()
}

/** 导出数据 */
const handleExport = () => {
  if (!list.value.length) {
    message.warning('没有数据可导出')
    return
  }

  Modal.confirm({
    title: '确认导出',
    content: `确定要导出 ${pagination.total} 条员工日志数据吗？`,
    okText: '确定',
    cancelText: '取消',
    onOk: async () => {
      try {
        const params = {
          userId: props.userId,
        }

        if (queryParam.operationTime) params.operationTime = queryParam.operationTime
        if (queryParam.operationReason) params.operationReason = queryParam.operationReason
        if (queryParam.operationName) params.operationName = queryParam.operationName
        if (queryParam.nickName) params.nickName = queryParam.nickName

        const hideLoading = message.loading('正在导出数据...', 0)

        await download(
          'system/user-log/export',
          params,
          `员工日志_${props.userName || '未知用户'}_${new Date().getTime()}.xlsx`
        )

        hideLoading()
        message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        message.error('导出失败')
      }
    },
  })
}

/** 多选变化 */
const onSelectChange = (keys, rows) => {
  selectedRowKeys.value = keys
  selectedRows.value = rows
}

/** 表格排序变化 */
const handleTableChange = (paginationData, filters, sorter) => {
  // 现在分页不在表格内部，这里主要处理排序
  if (sorter && sorter.field) {
    console.log('排序字段:', sorter.field, '排序方向:', sorter.order)
  }
}

/** 每页条数变化 */
const onShowSizeChange = (current, pageSize) => {
  pagination.pageSize = pageSize
  pagination.current = 1
  jumpPage.value = 1
  fetchData()
}

/** 分页变化 */
const changeSize = (current, pageSize) => {
  pagination.current = current
  pagination.pageSize = pageSize
  jumpPage.value = current
  onSelectChange([], [])
  fetchData()
}

/** 跳转页码 */
const handleJumpPage = () => {
  if (jumpPage.value && jumpPage.value >= 1) {
    const maxPage = Math.ceil(pagination.total / pagination.pageSize)
    if (jumpPage.value > maxPage) {
      jumpPage.value = maxPage
    }
    pagination.current = jumpPage.value
    onSelectChange([], [])
    fetchData()
  }
}

/** 弹窗关闭处理 */
const handleCancel = () => {
  console.log('关闭弹窗')
  emit('update:visible', false)
  emit('close')
}
</script>

<style scoped>
/* 弹窗基础样式 */
.employee-log-modal :deep(.ant-modal) {
  top: 50px;
}

.employee-log-modal :deep(.ant-modal-body) {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 20px 24px;
}

/* 表格容器 */
.table-container {
  position: relative;
  min-height: 300px;
}

.employee-log-modal :deep(.ant-spin-nested-loading) {
  min-height: 300px;
}

.employee-log-modal :deep(.ant-spin-container) {
  min-height: 300px;
}

/* 表格样式 - 参照 projectUser 页面 */
.employee-log-modal .optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  padding: 12px 8px;
}

.employee-log-modal .optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.employee-log-modal .optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
.employee-log-modal :deep(.ant-table) {
  border: none !important;
}

.employee-log-modal :deep(.ant-table-container) {
  border: none !important;
}

.employee-log-modal :deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

.employee-log-modal :deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

.employee-log-modal :deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

.employee-log-modal :deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

.employee-log-modal :deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
.employee-log-modal :deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

.employee-log-modal :deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

.employee-log-modal :deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

.employee-log-modal :deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

.employee-log-modal :deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 选中的行样式 - 去掉背景色 */
.employee-log-modal :deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

.employee-log-modal :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.employee-log-modal .optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 空状态样式 */
.empty-container {
  padding: 80px 0;
  text-align: center;
}

.employee-log-modal :deep(.ant-empty-image) {
  height: 80px;
  margin-bottom: 16px;
}

.employee-log-modal :deep(.ant-empty-description) {
  color: #999;
  font-size: 14px;
  margin-top: 8px;
}

/* 操作按钮区域 */
.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.data-total {
  color: #666;
  font-size: 13px;
  margin-left: auto;
}

/* 列样式 */
.index-column {
  color: #999;
  font-weight: 400;
}

.time-column {
  color: #1890ff;
  font-family: 'Monaco', 'Consolas', monospace;
}

.reason-column,
.remark-column {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .table-operations {
    flex-direction: column;
    align-items: flex-start;
  }

  .data-total {
    margin-left: 0;
    margin-top: 8px;
  }

  .employee-log-modal :deep(.ant-modal) {
    width: 95% !important;
    max-width: 95%;
    margin: 10px auto;
  }
}
</style>

<style>
/* 搜索栏输入框样式 */
.employee-log-modal .table-page-search-wrapper .ant-input,
.employee-log-modal .table-page-search-wrapper .ant-input:hover,
.employee-log-modal .table-page-search-wrapper .ant-input:focus {
  width: 180px !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.employee-log-modal .table-page-search-wrapper .ant-input-affix-wrapper,
.employee-log-modal .table-page-search-wrapper .ant-input-affix-wrapper:hover,
.employee-log-modal .table-page-search-wrapper .ant-input-affix-wrapper:focus {
  width: 180px !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.employee-log-modal .table-page-search-wrapper .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.employee-log-modal .table-page-search-wrapper .ant-picker,
.employee-log-modal .table-page-search-wrapper .ant-picker:hover,
.employee-log-modal .table-page-search-wrapper .ant-picker:focus {
  width: 180px !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 其他输入框保持原样式 */
.employee-log-modal .ant-input,
.employee-log-modal .ant-input:hover,
.employee-log-modal .ant-input:focus,
.employee-log-modal .ant-input-affix-wrapper,
.employee-log-modal .ant-input-affix-wrapper:hover,
.employee-log-modal .ant-input-affix-wrapper:focus,
.employee-log-modal .ant-picker,
.employee-log-modal .ant-picker:hover,
.employee-log-modal .ant-picker:focus {
  border-radius: 2px !important;
}

/* 按钮样式 */
.employee-log-modal .search-btn {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px 4px 4px 4px !important;
  height: 32px;
  padding: 0 15px;
}

.employee-log-modal .search-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.employee-log-modal .search-btn:disabled {
  background-color: #bae7ff !important;
  border-color: #bae7ff !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

.employee-log-modal .reset-btn {
  background-color: #f3f3f3 !important;
  border: none !important;
  color: #101010 !important;
  border-radius: 4px 4px 4px 4px !important;
  height: 32px;
  padding: 0 15px;
}

.employee-log-modal .reset-btn:hover {
  background-color: #f3f3f3 !important;
  border: none !important;
  color: #101010 !important;
}

.employee-log-modal .reset-btn:disabled {
  background-color: #f5f5f5 !important;
  border: none !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 去掉指定按钮的边框 */
.employee-log-modal .no-border-button {
  border: none !important;
}

.employee-log-modal .no-border-button:hover,
.employee-log-modal .no-border-button:focus {
  border: none !important;
}

/* 展开/收起按钮文字和图标颜色 - 去掉背景 */
.employee-log-modal .toggle-button {
  background: transparent !important;
  border: none !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.employee-log-modal .toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.employee-log-modal .toggle-button:hover,
.employee-log-modal .toggle-button:focus {
  background: transparent !important;
  border: none !important;
  color: #165dff !important;
  box-shadow: none !important;
}

.employee-log-modal .toggle-button:hover :deep(.anticon),
.employee-log-modal .toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 按钮区域样式 */
.employee-log-modal .table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 导出按钮样式 */
.employee-log-modal .export-btn {
  background-color: #f3f3f3 !important;
  border: none !important;
  color: #333333 !important;
  border-radius: 4px 4px 4px 4px !important;
  height: 32px;
  padding: 0 15px;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.employee-log-modal .export-btn:hover:not(:disabled) {
  background-color: #e6e6e6 !important;
  border: none !important;
  color: #333333 !important;
}

.employee-log-modal .export-btn:disabled {
  background-color: #f5f5f5 !important;
  border: none !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

/* 刷新图标 */
.employee-log-modal .refresh-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: all 0.3s;
  object-fit: contain;
  /* padding: 6px; */
  /* border: 1px solid #d9d9d9; */
  /* border-radius: 4px 4px 4px 4px; */
  background-color: #ffffff;
}

.employee-log-modal .refresh-icon:hover {
  border-color: #1890ff;
  background-color: #f5f5f5;
}

.employee-log-modal .refresh-icon.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.employee-log-modal .refresh-icon.disabled:hover {
  border-color: #d9d9d9;
  background-color: #ffffff;
}

/* 分页组件样式 - 参照 ../index.vue 页面 */
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 表格分页器 - 参照 ../index.vue 页面样式 */
.employee-log-modal :deep(.ant-pagination) {
  margin-top: 0;
  padding: 0;
  text-align: right;
}

/* 分页组件样式 - 去掉圆角 - 参照 ../index.vue 页面 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

/* 上一页/下一页按钮圆角为4px */
.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 4px !important;
}

/* 注意：分页中的输入框和选择框圆角为4px，样式在全局style区域定义 */
.employee-log-modal .pagination-wrapper :deep(.ant-input-number),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-input-number),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-input-number .ant-input-number),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-input-number .ant-input-number-input),
.employee-log-modal .pagination-wrapper .no-border-radius-input-number,
.employee-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number,
.employee-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number-input {
  border-radius: 4px !important;
}

.employee-log-modal .pagination-wrapper :deep(.ant-input-number-input),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-input-number .ant-input-number-input),
.employee-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number-input {
  border-radius: 4px !important;
}

/* 分页中的选择框圆角为4px - 覆盖 no-border-radius 类 */
.employee-log-modal .pagination-wrapper :deep(.ant-select-selector),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-select),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-select .ant-select-selector),
.employee-log-modal .pagination-wrapper .no-border-radius-select,
.employee-log-modal .pagination-wrapper .no-border-radius-select .ant-select-selector {
  border-radius: 4px !important;
}

.employee-log-modal .pagination-wrapper :deep(.ant-select-focused .ant-select-selector),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-select.ant-select-focused .ant-select-selector),
.employee-log-modal .pagination-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.employee-log-modal .pagination-wrapper .no-border-radius-select.ant-select-focused .ant-select-selector,
.employee-log-modal .pagination-wrapper .no-border-radius-select .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
}

/* 分页选中页数样式 - 蓝色背景白色文字 */
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active),
.employee-log-modal .pagination-wrapper .ant-pagination-item-active,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active a),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active a:hover),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active a:focus),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active a:visited),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active a),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active a:hover),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active a:focus),
.employee-log-modal .pagination-wrapper .ant-pagination-item-active a,
.employee-log-modal .pagination-wrapper .ant-pagination-item-active a:hover,
.employee-log-modal .pagination-wrapper .ant-pagination-item-active a:focus,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active a {
  color: #ffffff !important;
}

.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active:hover),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:hover),
.employee-log-modal .pagination-wrapper .ant-pagination-item-active:hover,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:hover {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active:hover a),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:hover a),
.employee-log-modal .pagination-wrapper .ant-pagination-item-active:hover a,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:hover a {
  color: #ffffff !important;
}

.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active:focus),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:focus),
.employee-log-modal .pagination-wrapper .ant-pagination-item-active:focus,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:focus {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item-active:focus a),
.employee-log-modal .pagination-wrapper :deep(.ant-pagination-item.ant-pagination-item-active:focus a),
.employee-log-modal .pagination-wrapper .ant-pagination-item-active:focus a,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:focus a {
  color: #ffffff !important;
}

/* 确认导出弹框按钮样式 */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 0 !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background: #165dff !important;
  border-color: #165dff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover {
  background: #4080ff !important;
  border-color: #4080ff !important;
}

/* 表格复选框样式 - 参照 projectUser 页面 */
.employee-log-modal .optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.employee-log-modal .optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 分页输入框圆角为4px - 全局样式确保生效 */
.employee-log-modal .pagination-wrapper .no-border-radius-input-number,
.employee-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number,
.employee-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number-input,
.employee-log-modal .pagination-wrapper .ant-input-number {
  border-radius: 4px !important;
}

.employee-log-modal .pagination-wrapper .no-border-radius-input-number .ant-input-number-input {
  border-radius: 4px !important;
}

/* 分页选择框圆角为4px - 全局样式确保生效 */
.employee-log-modal .pagination-wrapper .no-border-radius-select,
.employee-log-modal .pagination-wrapper .no-border-radius-select .ant-select-selector,
.employee-log-modal .pagination-wrapper .ant-select-selector {
  border-radius: 4px !important;
}

.employee-log-modal .pagination-wrapper .no-border-radius-select.ant-select-focused .ant-select-selector,
.employee-log-modal .pagination-wrapper .no-border-radius-select .ant-select-focused .ant-select-selector,
.employee-log-modal .pagination-wrapper .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
}

/* 分页选中页数样式 - 蓝色背景白色文字 - 全局样式确保生效 */
.employee-log-modal .pagination-wrapper .ant-pagination-item-active,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.employee-log-modal .pagination-wrapper .ant-pagination-item-active a,
.employee-log-modal .pagination-wrapper .ant-pagination-item-active a:hover,
.employee-log-modal .pagination-wrapper .ant-pagination-item-active a:focus,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active a,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active a:hover,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active a:focus {
  color: #ffffff !important;
}

.employee-log-modal .pagination-wrapper .ant-pagination-item-active:hover,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:hover {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.employee-log-modal .pagination-wrapper .ant-pagination-item-active:hover a,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:hover a {
  color: #ffffff !important;
}

.employee-log-modal .pagination-wrapper .ant-pagination-item-active:focus,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:focus {
  background: #165dff !important;
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.employee-log-modal .pagination-wrapper .ant-pagination-item-active:focus a,
.employee-log-modal .pagination-wrapper .ant-pagination-item.ant-pagination-item-active:focus a {
  color: #ffffff !important;
}

/* 上一页/下一页按钮圆角为4px - 全局样式确保生效 */
.employee-log-modal .pagination-wrapper .ant-pagination-prev,
.employee-log-modal .pagination-wrapper .ant-pagination-next,
.employee-log-modal .pagination-wrapper .ant-pagination-prev .ant-pagination-item-link,
.employee-log-modal .pagination-wrapper .ant-pagination-next .ant-pagination-item-link {
  border-radius: 4px !important;
}

.employee-log-modal .pagination-wrapper .ant-pagination-prev button,
.employee-log-modal .pagination-wrapper .ant-pagination-next button {
  border-radius: 4px !important;
}
</style>